export default (sectionId) =>
  new Promise((resolve, reject) => {
    window.axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}/restore`)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
